import { render, staticRenderFns } from "./Substances.vue?vue&type=template&id=38eed69d&"
import script from "./Substances.vue?vue&type=script&lang=js&"
export * from "./Substances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports